import clsx from 'clsx';
import React, { ForwardedRef } from 'react';

import styles from './Button.module.scss';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  keepColorWhenDisabled?: boolean;
};

const Button = (
  { keepColorWhenDisabled, className, children, ...otherProps }: Props,
  ref: ForwardedRef<HTMLButtonElement>,
): JSX.Element => (
  <button
    {...otherProps}
    className={clsx(className, styles.button, !keepColorWhenDisabled && styles.greyWhenDisabled)}
    ref={ref}
  >
    {children}
  </button>
);

export default React.forwardRef(Button);
